/* Meridian Fabric Showroom — inquiry rack + request pop-up
   A persistent "rack" (localStorage). Cards add/remove themselves; a floating
   button + drawer show the picks (with mill code). "Request these fabrics"
   opens an in-page modal (server-rendered {% form 'contact' %} lives in the
   showroom-grid section) that emails the inquiry — no separate page, no app.
   Self-contained; injects its own rack styles. */
(function () {
  var KEY = 'meridian_rack_v1';

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(x) { try { localStorage.setItem(KEY, JSON.stringify(x)); } catch (e) {} }
  function has(x, id) { return x.some(function (i) { return String(i.id) === String(id); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function styles() {
    if (document.getElementById('m-rack-css')) return;
    var s = document.createElement('style');
    s.id = 'm-rack-css';
    s.textContent = [
      '.m-rack-fab{position:fixed;right:20px;bottom:20px;z-index:9998;display:none;align-items:center;gap:8px;padding:12px 18px;border:none;border-radius:999px;background:var(--color-foreground,#16181d);color:var(--color-background,#fff);font:600 14px/1 inherit;cursor:pointer;box-shadow:0 6px 20px rgba(0,0,0,.25)}',
      '.m-rack-fab.is-visible{display:inline-flex}',
      '.m-rack-fab .m-rack-count{background:var(--color-background,#fff);color:var(--color-foreground,#16181d);border-radius:999px;min-width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;font-size:12px;padding:0 6px}',
      '.m-rack-overlay{position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:9999;opacity:0;visibility:hidden;transition:opacity .2s}',
      '.m-rack-overlay.is-open{opacity:1;visibility:visible}',
      '.m-rack-panel{position:fixed;top:0;right:0;height:100%;width:min(380px,90vw);background:var(--color-background,#fff);color:var(--color-foreground,#16181d);z-index:10000;transform:translateX(100%);transition:transform .25s ease;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.2)}',
      '.m-rack-panel.is-open{transform:none}',
      '.m-rack-head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid rgba(128,128,128,.25)}',
      '.m-rack-head h3{margin:0;font-size:1.1rem}',
      '.m-rack-close{border:none;background:none;font-size:26px;line-height:1;cursor:pointer;color:inherit}',
      '.m-rack-list{list-style:none;margin:0;padding:8px 0;overflow:auto;flex:1}',
      '.m-rack-item{display:flex;align-items:center;gap:12px;padding:12px 20px;border-bottom:1px solid rgba(128,128,128,.15)}',
      '.m-rack-item__t{flex:1;font-size:.9rem;line-height:1.3}',
      '.m-rack-item__code{display:block;font-size:.7rem;color:#888;letter-spacing:.03em;margin-top:2px}',
      '.m-rack-item__x{border:none;background:none;color:#999;cursor:pointer;font-size:20px;line-height:1}',
      '.m-rack-empty{padding:40px 20px;text-align:center;color:#888;font-size:.9rem}',
      '.m-rack-foot{padding:16px 20px;border-top:1px solid rgba(128,128,128,.25)}',
      '.m-rack-foot .m-rack-go{display:block;width:100%;text-align:center;background:var(--color-foreground,#16181d);color:var(--color-background,#fff);border:none;cursor:pointer;padding:12px;border-radius:8px;font:600 14px/1 inherit}',
      '.m-rack-foot .m-rack-go:disabled{opacity:.4;cursor:not-allowed}',
      '.m-btn--solid.is-in-rack{background:transparent;color:var(--color-foreground,#16181d);border-color:var(--color-foreground,#16181d)}'
    ].join('');
    document.head.appendChild(s);
  }

  var fab, overlay, panel, listEl, goEl;

  function buildUI() {
    fab = document.createElement('button');
    fab.className = 'm-rack-fab'; fab.type = 'button';
    fab.innerHTML = 'Your rack <span class="m-rack-count">0</span>';
    overlay = document.createElement('div'); overlay.className = 'm-rack-overlay';
    panel = document.createElement('aside'); panel.className = 'm-rack-panel';
    panel.setAttribute('aria-label', 'Your fabric rack');
    panel.innerHTML =
      '<div class="m-rack-head"><h3>Your rack</h3>' +
      '<button class="m-rack-close" type="button" aria-label="Close">&times;</button></div>' +
      '<ul class="m-rack-list"></ul>' +
      '<div class="m-rack-foot"><button type="button" class="m-rack-go m-js-openmodal">Request these fabrics &rarr;</button></div>';
    document.body.appendChild(fab); document.body.appendChild(overlay); document.body.appendChild(panel);
    listEl = panel.querySelector('.m-rack-list');
    goEl = panel.querySelector('.m-rack-go');
    fab.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    panel.querySelector('.m-rack-close').addEventListener('click', closeDrawer);
  }
  function openDrawer() { overlay.classList.add('is-open'); panel.classList.add('is-open'); }
  function closeDrawer() { overlay.classList.remove('is-open'); panel.classList.remove('is-open'); }

  function renderDrawer() {
    var items = load();
    if (fab) { fab.querySelector('.m-rack-count').textContent = items.length; fab.classList.toggle('is-visible', items.length > 0); }
    if (listEl) {
      if (!items.length) {
        listEl.innerHTML = '<li class="m-rack-empty">Your rack is empty. Add fabrics to request info or samples.</li>';
        if (goEl) goEl.disabled = true;
      } else {
        listEl.innerHTML = items.map(function (i) {
          return '<li class="m-rack-item" data-id="' + esc(i.id) + '">' +
            '<span class="m-rack-item__t">' + esc(i.title) +
            '<span class="m-rack-item__code">' + esc(i.id) + (i.tech ? ' · ' + esc(i.tech) : '') + '</span></span>' +
            '<button class="m-rack-item__x" type="button" aria-label="Remove">&times;</button></li>';
        }).join('');
        if (goEl) goEl.disabled = false;
      }
    }
    document.querySelectorAll('.m-js-rack').forEach(function (b) {
      var inrack = has(items, b.getAttribute('data-id'));
      b.classList.toggle('is-in-rack', inrack);
      b.textContent = inrack ? '✓ In rack' : 'Add to rack';
    });
  }

  /* ---- request modal (form markup is server-rendered in the section) ---- */
  function modal() { return document.querySelector('.m-js-modal'); }

  function reqRow(i) {
    return '<li class="m-req-row" data-id="' + esc(i.id) + '">' +
      '<span class="m-req-row__t">' + esc(i.title) +
      '<span class="m-req-row__code">' + esc(i.id) + (i.tech ? ' · ' + esc(i.tech) : '') + '</span></span>' +
      '<select class="m-req-choice" aria-label="Request type for ' + esc(i.title) + '">' +
      '<option value="Info + Samples">Info + Samples</option>' +
      '<option value="Info only">Info only</option>' +
      '<option value="Samples only">Samples only</option>' +
      '</select>' +
      '<button type="button" class="m-req-row__x" aria-label="Remove">&times;</button></li>';
  }

  function populateModal() {
    var m = modal(); if (!m) return;
    var list = m.querySelector('#m-req-list'); if (!list) return; // success state
    var items = load();
    var empty = m.querySelector('#m-req-empty');
    var submit = m.querySelector('#m-req-submit');
    if (!items.length) {
      list.hidden = true; if (empty) empty.hidden = false; if (submit) submit.disabled = true;
    } else {
      list.hidden = false; if (empty) empty.hidden = true; if (submit) submit.disabled = false;
      list.innerHTML = items.map(reqRow).join('');
    }
    compile();
  }

  function compile() {
    var m = modal(); if (!m) return;
    var list = m.querySelector('#m-req-list'); var body = m.querySelector('#m-req-body');
    if (!list || !body) return;
    var items = load();
    var lines = items.map(function (i) {
      var sel = list.querySelector('[data-id="' + cssEsc(i.id) + '"] .m-req-choice');
      var choice = sel ? sel.value : 'Info + Samples';
      return '• ' + i.title + ' · ' + i.id + (i.tech ? ' · ' + i.tech : '') + ' — ' + choice;
    });
    var notes = m.querySelector('#m-req-notes');
    var txt = 'Sample / info request — ' + items.length + ' fabric(s):\n' + lines.join('\n');
    if (notes && notes.value.trim()) txt += '\n\nAdditional notes:\n' + notes.value.trim();
    body.value = txt;
  }

  function cssEsc(s) { return String(s).replace(/["\\\]]/g, '\\$&'); }

  function openModal() {
    var m = modal(); if (!m) return;
    populateModal();
    m.hidden = false;
    closeDrawer();
  }
  function closeModal() { var m = modal(); if (m) m.hidden = true; }

  /* ---- delegated events ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.m-js-rack');
    if (add) {
      var items = load(); var id = add.getAttribute('data-id');
      if (has(items, id)) items = items.filter(function (i) { return String(i.id) !== String(id); });
      else items.push({ id: id, title: add.getAttribute('data-title'), tech: add.getAttribute('data-tech') });
      save(items); renderDrawer(); return;
    }
    if (e.target.closest('.m-js-openmodal')) { openModal(); return; }
    if (e.target.closest('.m-js-modal-close')) { closeModal(); return; }
    var mo = e.target.closest('.m-js-modal');
    if (mo && e.target === mo) { closeModal(); return; } // click backdrop
    var rmDrawer = e.target.closest('.m-rack-item__x');
    if (rmDrawer) {
      var did = rmDrawer.closest('.m-rack-item').getAttribute('data-id');
      save(load().filter(function (i) { return String(i.id) !== String(did); })); renderDrawer(); return;
    }
    var rmReq = e.target.closest('.m-req-row__x');
    if (rmReq) {
      var rid = rmReq.closest('.m-req-row').getAttribute('data-id');
      save(load().filter(function (i) { return String(i.id) !== String(rid); }));
      populateModal(); renderDrawer(); return;
    }
  });

  document.addEventListener('change', function (e) { if (e.target.closest('.m-req-choice')) compile(); });
  document.addEventListener('input', function (e) { if (e.target.id === 'm-req-notes') compile(); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.id === 'm-req-form') {
      if (!load().length) { e.preventDefault(); return; }
      compile();
    }
  });

  function init() {
    styles(); buildUI(); renderDrawer();
    // if the section reloaded into a success/error state, open the modal to show it
    var m = modal();
    if (m && m.getAttribute('data-open') === 'true') m.hidden = false;
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();